module.exports = __webpack_public_path__ + "static/img/inspection.232d328d.png";